export const fieldtype = {
    number: 'number',
    datetime: 'datetime',
    image: 'image',
    url: 'url',
    phone: 'phone',
    linkedfield: 'linkedField',
    check: 'check',
    lookup: 'lookup',
    textarea: 'textarea',
    text: 'text',
    email: 'email',
    formula: 'formula',
    pointer: 'pointer'
}
